import { FC } from 'react';

// Common
import Page from 'app/common/page';

// Components
import Thresholds from './thresholds';

// Material
import { Container, makeStyles } from '@material-ui/core';
import TimelineLimits from './timeline_limits';

// Styles
const useStyles = makeStyles((theme) => ({
  root: {
    backgroundColor: theme.palette.background.default,
    minHeight: '100%',
    height: '100%',
    paddingBottom: theme.spacing(3),
    paddingTop: theme.spacing(3)
  }
}));

const SettingsV2: FC = () => {
  const classes = useStyles();

  return (
    <Page className={classes.root} title="Paramètres">
      <Container maxWidth={false}>
        <Thresholds />
        <TimelineLimits />
      </Container>
    </Page>
  );
};

export default SettingsV2;
